export default {
    getHeaderFields: state => state.headerFields,
    getFormActions: state => state.formActions,
}
